<template>
  <section>
    <div
      class="section full-height over-hide swiper-container z-10"
      id="hero-slider"
    >
      <ul class="swiper-wrapper case-study-wrapper">
        <li
          v-for="(slide, index) in caseStudies"
          :key="index"
          class="swiper-slide full-height case-study-name"
          @mouseenter="setActive(index)"
          :class="{ active: index === active }"
        >
          <router-link
            :to="{ name: 'Case Study', params: { slug: slide.slug } }"
          >
            <h1>{{ slide.name }}</h1>
          </router-link>
        </li>
      </ul>

      <!-- Background Images -->
      <div class="swiper-scrollbar"></div>
    </div>
    <SwiperImages :active="active" :slides="caseStudies" />
  </section>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";

import { mapGetters, mapActions } from "vuex";

import SwiperImages from "@/components/SwiperImages";
export default {
  components: {
    SwiperImages
  },
  watch: {
    caseStudies() {
      this.intialiseSwiper();
    }
  },
  data() {
    return {
      active: 0,
      virtualData: {
        slides: []
      }
    };
  },
  methods: {
    setActive(n) {
      this.active = n;
    },
    ...mapActions({ fetchCases: "caseStudies/fetchCases" }),
    intialiseSwiper() {
      const vue = this;
      new Swiper(".swiper-container", {
        virtual: {
          slides: vue.caseStudies,
          renderExternal(data) {
            vue.virtualData = data;
          }
        },
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
          draggable: true,
          dragSize: "19"
        },
        slidesPerView: 1,
        resistance: true,
        resistanceRatio: 0,
        speed: 800,
        spaceBetween: 0,
        autoplay: false,
        mousewheel: true,
        freeMode: false,
        grabCursor: true,
        touchStartPreventDefault: false,
        breakpoints: {
          // when window width is >= 1200px
          1200: {
            freeMode: true,
            slidesPerView: 3
          }
        }
      });
    }
  },
  computed: {
    ...mapGetters({ caseStudies: "caseStudies/caseStudies" })
  },
  mounted() {
    this.intialiseSwiper();
  }
  //there was some strange error which caused the case studies page to go back to the designs page after navigating away. This is a stop-gap approach to prevent that from happening by checking to see if the image query is being set and then preventing the navigation
  // beforeRouteLeave(to, from, next) {
  //   if (to.name == "Designs" && to.query.image) {
  //     return;
  //   }
  //   next();
  // }
};
</script>

<style lang="scss" scoped>
.z-10 {
  z-index: 10;
}

.swiper-wrapper {
  position: relative;
  padding: 0;
  margin: 0;
  list-style: none;
  //   z-index: 3;
  cursor: grab;

  &:active,
  :focus {
    cursor: grabbing;
    cursor: url(../assets/img/grabbing.png) 28 15, grabbing;
  }
}

.swiper-slide {
  position: relative;
  padding: 0;
  margin: 0;
  width: auto;
  z-index: 3;
  cursor: grab;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 250ms linear;
  float: left;

  &:active,
  :focus {
    cursor: grabbing;
    cursor: url(../assets/img/grabbing.png) 28 15, grabbing;
  }

  a {
    cursor: pointer;
    margin: 0 100px;

    &:hover {
      text-decoration: none;
    }
  }

  h1 {
    font-weight: 900;
    -webkit-text-stroke: 2px #fff;
    text-stroke: 2px #fff;
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
    color: transparent;
    position: relative;
    font-size: 60px;
    letter-spacing: 3px;
    line-height: 1;
    font-weight: 800;
    text-align: center;
    padding: 0 5px;
    cursor: pointer;
    width: 100%;
    z-index: 0;
    transition: all 200ms linear;

    &:hover:before {
      background-color: $primary;
    }

    &:before {
      background-color: rgba(255, 255, 255, 0.1);
      position: absolute;
      content: "";
      left: 0;
      height: 0;
      bottom: 0px;
      background-color: rgba(255, 255, 255, 0.5);
      cursor: pointer;
      width: 100%;
      z-index: -1;
      opacity: 0;
      transition: all 200ms linear;
    }
  }

  @media (max-width: 1199px) {
    width: 40%;
    a {
      margin: 0;
    }
    h1 {
      font-size: 40px;
      letter-spacing: 1px;
    }
  }

  @media (max-width: 991px) {
    width: 50%;

    h1 {
      font-size: 30px;
    }
  }

  @media (max-width: 575px) {
    width: auto;

    a {
      margin: 0 25px;
    }
  }
}

.swiper-scrollbar {
  border-radius: 0;
  position: relative;
  -ms-touch-action: none;
  background: rgba(255, 255, 255, 0.2);
}

.swiper-container-horizontal {
  .swiper-scrollbar {
    position: absolute;
    left: 30%;
    right: 30%;
    bottom: 35px;
    z-index: 50;
    height: 1px;
    width: 40%;

    @media (max-width: 991px) {
      left: 70px;
      right: 70px;
      width: calc(100% - 140px);
    }
  }
}

/deep/ .swiper-scrollbar-drag {
  height: 19px;
  border-radius: 50%;
  position: relative;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
  left: 0;
  top: -9px;
  cursor: pointer;
  transition: 0.3s background ease;

  &:active,
  :focus {
    cursor: grabbing;
    box-shadow: 0 0 0 15px rgba(255, 255, 255, 0.1);
    background: $primary;
  }
}

.case-study-name h1 {
  opacity: 0.6;
  transition: all 200ms linear;
}
.case-study-name h1:hover {
  opacity: 1;
}
.case-study-name.active h1 {
  opacity: 1;
  -webkit-text-stroke: 2px transparent;
  text-stroke: 2px transparent;
  -webkit-text-fill-color: #fff;
  text-fill-color: #fff;
  color: #fff;
}
.case-study-name.active h1:before {
  opacity: 1;
  height: 20px;
}

@media (max-width: 1199px) {
  .case-study-name.active h1:before {
    height: 10px;
  }
  .swiper-container-horizontal > .swiper-scrollbar {
    bottom: 25px;
  }
  .case-study-images li .hero-number,
  .case-study-images li .hero-number-fixed {
    bottom: 50px;
  }
}
</style>
